import ChannelAdmins from "./channel-admins";
import "./settings-admin.scss";
import "./channel-admins.scss";

export const SettingsAdminsOverview = (): JSX.Element => {
	return (
		<ChannelAdmins overview />
	);
};

export default function SettingsAdmins(): JSX.Element {
	return (
		<ChannelAdmins />
	);
}
